import { render, staticRenderFns } from "./BookingStep2.vue?vue&type=template&id=ec8e8ae6&"
import script from "./BookingStep2.vue?vue&type=script&lang=js&"
export * from "./BookingStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports